module.exports = __webpack_public_path__ + "img/ic-outgoing.007b12e8.svg";